import React, { Component } from 'react'
import { css } from 'emotion'
import {
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
  MediaQuery,
} from 'components'
import { foodGallery } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center m="0 auto" w="100%" mt="-1px" bg="#171719">
          <CFImage src={foodGallery} alt="Food Gallery" w="100%" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          column
          center
          maxWidth="1400px"
          w="100%"
          h="550px"
          mt="-5px"
          image={`url(${foodGallery}) center / cover no-repeat`}
          style={{ backgroundAttachment: 'fixed' }}
        ></CFView>
      </DefaultScreen>
    </CFView>
  )
}
